import { h } from "omi";

export function CountryKGIcon() {
  return (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#a)">
        <path
          d="M10 20c5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C4.4771 0 0 4.4771 0 10c0 5.5228 4.4771 10 10 10Z"
          fill="#D80027"
        />
        <path
          d="m14.8901 10.0001-1.9982.9399 1.0641 1.9354-2.17-.4152-.2749 2.1921-1.5115-1.6121-1.5114 1.6121-.275-2.1921-2.1698.4152 1.064-1.9355-1.9983-.9398 1.9984-.9399-1.0641-1.9355 2.1698.4153.275-2.1921L9.9997 6.96l1.5116-1.6121.2748 2.192 2.1701-.4152-1.0642 1.9356 1.9982.9398Z"
          fill="#FFDA44"
        />
        <path
          d="M10.0003 13.0428c1.6808 0 3.0434-1.3626 3.0434-3.0435 0-1.6809-1.3626-3.0435-3.0434-3.0435-1.6809 0-3.0435 1.3626-3.0435 3.0435 0 1.6809 1.3626 3.0435 3.0435 3.0435Z"
          fill="#D80027"
        />
        <path
          d="M8.4784 10.0002c-.0733 0-.1457.0038-.2172.0109a1.732 1.732 0 0 0 .407 1.1071 3.0492 3.0492 0 0 1 .588-.9735 2.161 2.161 0 0 0-.7778-.1445ZM9.4153 11.6391c.1828.0653.3796.1012.5849.1012.2054 0 .4022-.0359.585-.1012a2.1743 2.1743 0 0 0-.585-1.0146 2.1747 2.1747 0 0 0-.585 1.0146ZM11.5065 9.131c-.3007-.5197-.8623-.8698-1.5061-.8698-.6437 0-1.2053.35-1.506.8699a3.0234 3.0234 0 0 1 1.506.4092 3.0235 3.0235 0 0 1 1.5061-.4092ZM10.7439 10.1449c.253.2821.4536.6119.588.9735a1.7313 1.7313 0 0 0 .407-1.1071 2.1962 2.1962 0 0 0-.2171-.0108 2.1595 2.1595 0 0 0-.7779.1444Z"
          fill="#FFDA44"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
